module.exports = __webpack_public_path__ + "img/HongKongTrust9.c22008e5.png";